import {useQuery} from '@apollo/react-hooks';

import type {
    GetAnalyticsStatus as GetAnalyticsStatusQuery,
    AnalyticsStatusFragment as AnalyticsStatus,
} from '../../../graphql-types';

import GET_ANALYTICS_STATUS from './graphql/queries/get-analytics-status.graphql';

export const useGetAnalyticsStatus = (
    skip?: boolean
): {
    analyticsStatus: AnalyticsStatus | null | undefined;
    isLoading: boolean;
    refetch: () => Promise<any>;
} => {
    const {
        data,
        loading: isLoading,
        refetch,
    } = useQuery<GetAnalyticsStatusQuery, Record<any, any>>(GET_ANALYTICS_STATUS, {
        skip,
    });

    return {
        analyticsStatus: data ? data.analyticsStatus : undefined,
        isLoading,
        refetch,
    };
};
